<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mx-2" icon v-bind="attrs" v-on="on"> <v-icon>mdi-help-circle-outline</v-icon></v-btn>
    </template>

    <v-card flat>
      <v-card-title :style="partnerColor.gradientStyle">
        <span :style="`color:white`">{{ $t("components.thg.ThgVehicleTable.help.title") }}</span>
        <v-spacer />
        <v-btn :color="partnerColor.primaryDarken_3" icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="mt-4">
        <v-row>
          <v-col cols="12">
            <v-chip small color="success"></v-chip> {{ $t("components.thg.ThgVehicleTable.help.success") }}
          </v-col>
          <v-col cols="12">
            <v-chip small color="info"></v-chip> {{ $t("components.thg.ThgVehicleTable.help.info") }}
          </v-col>
          <v-col cols="12">
            <v-chip small color="warning"></v-chip> {{ $t("components.thg.ThgVehicleTable.help.warning") }}
          </v-col>
          <v-col cols="12">
            <v-chip small color="error"></v-chip> {{ $t("components.thg.ThgVehicleTable.help.error") }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { PartnerColor } from "@/lib/partnerColor";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ThgVehicleTableLegendDialog extends DarkModeHighlightMixin {
  dialog = false;

  close() {
    this.dialog = false;
  }

  partnerColor = new PartnerColor();
}
</script>
